
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/loans",
      function () {
        return require("private-next-pages/account/loans/index.p.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/loans"])
      });
    }
  